import { render, staticRenderFns } from "./ServiceDistributionChild.vue?vue&type=template&id=62ae1ffc&scoped=true&"
import script from "./ServiceDistributionChild.vue?vue&type=script&lang=js&"
export * from "./ServiceDistributionChild.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDistributionChild.vue?vue&type=style&index=0&id=62ae1ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae1ffc",
  null
  
)

export default component.exports